import { BaseService } from "./BaseService";
import { FilePurpose, FilesOutput } from "@/interfaces/files";

interface UploadInput {
  file: File;
  purpose: FilePurpose;
}
export class FileService extends BaseService<FilesOutput, FilesOutput> {
  constructor() {
    super();
    this.path = "files";
  }

  async upload(input: UploadInput): Promise<FilesOutput> {
    const formData = new FormData();
    formData.append("file", input.file);
    formData.append("purpose", input.purpose);

    // Use the new createFormData method from BaseService
    return this.createFormData<FilesOutput>(formData);
  }
}
